<template>
  <card>
    <list v-if="$store.state.user.is_root" :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink"
      :cardLink="cardLink" :isUpdate="true" :isAdd="true" :itemLink="itemLink" :setLink="setLink" :openItem="true"
      :fields="fields" :searchDisable="true" @change="change" @changeFunction="changeFunction" v-model="val" />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  data() {
    return {
      val: [],
      modalCreate: "category",
      fields: [

        {
          key: "title",
          label: "Название",
          type: "field",
          textType: "text",
          isMultiLang: true,
        },
        {
          key: "disable_timetable",
          label: "Без расписания",
          type: "checkbox",
        },
        {
          key: "key",
          label: "Ключ",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_category",
      itemLink: "categories",
      setLink: "categories",
      columns: [
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          title: 'Не используется в расписании',
          key: 'disable_timetable',
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>

</style>
